( function ( $ ) {

	$( '.services__item__link' ).on( 'click', function( event ){
		event.preventDefault();
		const service = $( this ).attr( 'href' );
		$( service ).fadeIn( 300 );
	} );

	$( '.service__bg' ).on( 'click', function( event ) {
		event.stopPropagation();
		if ( $( event.target ).closest( '.service' ).length ) {
			return;
		}
		$( this ).fadeOut( 300 );
	} );

	$( '.service__close' ).on( 'click', function( event ) {
		event.stopPropagation();
		$( this ).closest( '.service__bg' ).fadeOut( 300 );
	} );
} )( jQuery );
